import { Component } from 'react';
import { createRoot } from 'react-dom/client';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, FreeMode, Thumbs, A11y, Keyboard } from 'swiper/modules';


import { useEffect, useState } from 'react';
import { MultiSizeImage } from "./ImageGallery.interface";

// Import Swiper styles
import '/node_modules/Swiper/swiper-bundle.min.css';
import '/node_modules/swiper/modules/free-mode.min.css';
import '/node_modules/swiper/modules/navigation.min.css';
import '/node_modules/swiper/modules/thumbs.min.css';
import '/node_modules/swiper/modules/a11y.min.css';
import "./ImageGallery.css";


const API_URL = "/api/ImageGallery";
import Helper from "Interfaces/Helper";
import ComponentHeader from "GeneralComponents/ComponentHeader";
import Consts from "Interfaces/Consts";

import Direction from 'Interfaces/Directions';

// configure Swiper to use modules
//SwiperCore.use([Navigation, Pagination, FreeMode, Thumbs, A11y, Keyboard]);
//const [thumbsSwiper, setThumbsSwiper] = useState<SwiperCore>();



import { register, SwiperContainer } from 'swiper/element/bundle';

type Props = {
    title: string;
    description: string;
    imageGalleryId: string;
    currentPageId: string;
    componentID: string;
}

register();


class ImageGallery extends Component {


    descFound: boolean = false;
    copyRightFound: boolean = false;
    descMainImgClass: string = "";

    state:
        {
            componentTitle: string;
            componentDescription: string;
            componentId: string;
            componentImageGalleryId: string;
            error: boolean;
            items: MultiSizeImage[];
            currentPageId: string;
            dir: string;
            

        };
    props: Props;


    constructor(props) {

        super(props);

        this.state = {

            componentTitle: this.props.title,
            componentDescription: this.props.description,
            componentId: this.props.componentID,
            componentImageGalleryId: this.props.imageGalleryId,
            error: false,
            items: [],
            currentPageId: this.props.currentPageId,
            dir: getComputedStyle(document.documentElement).direction
           

        };


    }

    componentDidMount() {

        try {
            //debugger;
            Helper.fetchData({ API_URL, queryId: this.state.componentImageGalleryId, pageId: this.state.currentPageId })
                .then(
                    (result) => {
                        this.setState({
                            isLoaded: true,
                            items: result
                        });

                      
                    },
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error: true
                        });
                    }
                )
        }
        catch (err) {
            console.log(err);
        }


    }

    componentDidUpdate = () => {

        const navMessage = { prevSlideMessage: Consts.prevSlideMessage, nextSlideMessage: Consts.nextSlideMessage }


        const swiperEl = document.getElementById('imageGallerySwiper-' + this.state.componentId) as SwiperContainer;

        const swiperEl2 = document.getElementById("mageGallerySwiperThumb-" + this.state.componentId) as SwiperContainer;



        if (this.state.items.length > 0 && swiperEl["speed"] == undefined) {

            const swiperParams = {
                loop: false,
                //spaceBetween: 60,
                navigation: true,
                speed: 900,
                centeredSlides: true,
                dir: Direction,
                pagination: { type: "fraction" },
                a11y: { navMessage },
                keyboard: { enabled: true, onlyInViewport: false },
                injectStyles: [`
                    .swiper-button-next svg, .swiper-button-prev svg {
                    width: 10px;
                    height: 10px;  
                    margin-top:8px;                   
                   
                    @media (min-width: 1024px) {
                        width: auto;
                        height: auto;
                        margin-top:14px;         
                    }}`,
                ],
                // injectStylesUrls: ['/css/Components/ImageGallery.min.css'],
                on: {
                    afterInit: (swiper) => {
                       // console.log(swiper.thumbs);
                    },
                   
                },
                breakpoints: {
                    0: {
                        spaceBetween: 20,
                    },
                    1024: {
                        spaceBetween: 60,
                    },
                },
            };

            Object.assign(swiperEl, swiperParams);

            swiperEl.initialize();




        }
        if (this.state.items.length > 0 && swiperEl2["speed"] == undefined) {

            const swiperParams2 = {
                loop: false,
                spaceBetween: 30,
               // slidesPerView: 4,
                freeMode: true,
                watchSlidesProgress: true,

                slidesPerView: "auto",


                centerInsufficientSlides: true,
                updateOnWindowResize: true,
                speed: 100,
                grabCursor: true,
                dir: Direction,
                keyboard: { enabled: true, onlyInViewport: false },
                         
                breakpoints: {
                    0: {
                      //  slidesPerView: 4,
                        spaceBetween: 15,

                    },
                    768: {
                       // slidesPerView: 6,
                        spaceBetween: 20,

                    },
                    1024: {
                      //  slidesPerView: 10,
                        spaceBetween: 20,

                    },
                    1200: {
                      //  slidesPerView: 7,
                        spaceBetween: 20,

                    },
                },



                on: {
                    init: function (swiper) {
                       // console.log(swiper);
                    },
                    afterInit: function (swiper) {
                       // console.log(swiper);
                    },

                },
            };

            Object.assign(swiperEl2, swiperParams2);
            swiperEl2.initialize();
        }


    }

    mainImgDesc = () => {



        if (this.state.items.length > 0) {


            if (this.state.items.some(el => el.description !== "")) {
                this.descFound = true;
            }

            if (this.state.items.some(el => el.copyRight !== "")) {
                this.copyRightFound = true;
            }


            if (!this.descFound && !this.copyRightFound) { this.descMainImgClass = "no-desc"; }
            if (this.descFound || this.copyRightFound) { this.descMainImgClass = "one-desc"; }
            if (this.descFound && this.copyRightFound) { this.descMainImgClass = ""; }

        }

        return this.descMainImgClass;
    }
    render() {

       


        let arrMainImg = [];
        this.state.items.map((bigImgitem, index) =>
            arrMainImg.push(<swiper-slide class="swiper-slide" key={index}>
                <img alt={bigImgitem.title} src={bigImgitem.url} />
                {
                    this.descFound != undefined &&
                    <div className="imgDesc">{bigImgitem.description}</div>
                }

                {
                    bigImgitem.copyRight &&
                    <div className="imgCopyRight"> &#169; {bigImgitem.copyRight}</div>
                }
            </swiper-slide>))



        let arrThumbImg = [];
        this.state.items.map((thumbImgitem, index) =>
            arrThumbImg.push(<swiper-slide class="swiper-slide" key={index} tabIndex={0} ><img alt={thumbImgitem.title} src={thumbImgitem.rectangleImage} /></swiper-slide>))


        return (
            <div className="container px-2 px-md-4 pt-3 pb-3">
                <ComponentHeader  disptitle={this.state.componentTitle} dispdescription={this.state.componentDescription} light={true} />

                <div className="mst-imgGallery-container">
                    <div className={`imageGalleryBig swiper ${this.mainImgDesc()}`}>


                        <swiper-container init={false}
                            class={`swiper-wrapper swiper-container ${Direction == "rtl" ? "swiper-container-rtl" : "swiper-container-ltr"} `}
                            id={`imageGallerySwiper-` + this.state.componentId} thumbs-swiper={`.mageGallerySwiperThumb-${this.state.componentId}`}
                        >

                            {arrMainImg}
                        </swiper-container>

                    </div>
                    <div className={`swiper  imageGalleryThumb ${"imageGalleryThumb-" + this.state.componentId}`}>

                        <swiper-container init={true} class={`mageGallerySwiperThumb-${this.state.componentId} swiper-wrapper`} id={`mageGallerySwiperThumb-${this.state.componentId}`} >

                            {arrThumbImg}


                        </swiper-container>
                    </div>


                </div>

                
            </div>
        );
    }
}




var elements = document.querySelectorAll('[id^="ImageGallery-"]');


for (var i = 0; i < elements.length; i++) {


    var rootElement = document.getElementById(elements[i].id);
    var root = createRoot(rootElement);
    root.render(
        <ImageGallery
            title={rootElement.getAttribute('component-title')}
            description={rootElement.getAttribute('component-description')}
            imageGalleryId={rootElement.getAttribute('component-imageGalleryId')}
            currentPageId={rootElement.getAttribute('component-currentPageId')}
            componentID={rootElement.getAttribute('component-id')}



        />);

}
